export default "__VITE_ASSET__Czg8q1Fv__"